import { useState } from '@max/max';
const isWeb = true;
import { AntiReqTool } from '@nibfe/h5guard-request';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { request as maxRequest } from '@max/meituan-uni-network';
export const AJAX_ERROR_NAME = '网络错误';
const API_MAP = {
    PROD: 'https://apihotel.meituan.com',
    TEST: 'https://papi.sankuai.com/api/req/55c7984e-3ce0-443d-8313-23dae5d52a9b/',
    SL: 'https://yangzezhong-pkgpn-sl-api.hotel.test.meituan.com'
};
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus[RequestStatus["LOADING"] = 1] = "LOADING";
    RequestStatus[RequestStatus["SUCCESS"] = 2] = "SUCCESS";
    RequestStatus[RequestStatus["ERROR"] = 3] = "ERROR";
    RequestStatus[RequestStatus["LOADING_MORE"] = 4] = "LOADING_MORE";
    RequestStatus[RequestStatus["LOADING_MORE_SUCCESS"] = 5] = "LOADING_MORE_SUCCESS";
    RequestStatus[RequestStatus["LOADING_MORE_ERROR"] = 6] = "LOADING_MORE_ERROR";
})(RequestStatus || (RequestStatus = {}));
export function useRequest(path, options) {
    const { raw = false, showLoading = false, loadingText, method = 'POST' } = options || {};
    const ctx = useMonitorEngineContext();
    let apiPath = API_MAP.PROD;
    const queryParams = ctx._runtimeInfo?.queryParams || {};
    // if (queryParams.isMock) {
    //   apiPath = API_MAP.TEST;
    // }
    const [requestStatus, setRequestStatus] = useState(RequestStatus.SUCCESS);
    const request = async (params) => {
        try {
            const { token } = ctx._runtimeInfo.commonParams;
            setRequestStatus(RequestStatus.LOADING);
            let finalRequestParams = params;
            if (true) {
                try {
                    const antiReq = new AntiReqTool({
                        autoFillParams: true
                    });
                    // @ts-ignore
                    finalRequestParams = antiReq.addCommonParams(finalRequestParams);
                }
                catch {
                    ctx._raptorReport.monitorReportLog('请求加上反爬参数错误', '请求加上反爬参数错误', {
                        level: 'warn',
                        category: 'jsError'
                    });
                }
            }
            const response = await new Promise((resolve, reject) => {
                maxRequest({
                    url: `${apiPath}${path}`,
                    // TODO: important,上线前检查
                    data: {
                        ...finalRequestParams,
                        token: undefined
                    },
                    method,
                    header: {
                        'content-type': 'application/json',
                        token
                    },
                    _meituan: {
                        requestType: 'MRNUtils',
                        mrnChannel: 'hotel'
                    },
                    success(res) {
                        ctx._raptorReport.monitorReportNetworkSuccess?.({
                            apiPath: path
                        });
                        if (raw) {
                            resolve(res);
                            return;
                        }
                        if (res?.data?.status === 0) {
                            const templateRes = res?.data?.data;
                            resolve(templateRes);
                        }
                        else {
                            const error = new Error(AJAX_ERROR_NAME);
                            error.name = AJAX_ERROR_NAME;
                            error.message = '请求接口异常-code非0';
                            let tags = {};
                            try {
                                tags = {
                                    response: JSON.stringify(res),
                                    params: JSON.stringify(finalRequestParams)
                                };
                            }
                            catch (e) { }
                            ctx._raptorReport.monitorReportLog?.('接口请求异常', error, {
                                level: 'info',
                                category: 'ajaxError',
                                tags
                            });
                            reject(error);
                        }
                    },
                    fail(error) {
                        ctx._raptorReport.monitorReportNetworkFailed?.({
                            apiPath: path
                        });
                        if (typeof error === 'object') {
                            error.name = AJAX_ERROR_NAME;
                            error.message = '请求接口异常-网络异常';
                        }
                        let tags = {};
                        try {
                            tags = {
                                errorInfo: JSON.stringify(error),
                                params: JSON.stringify(finalRequestParams),
                                apiPath: path
                            };
                        }
                        catch (e) { }
                        ctx._raptorReport.monitorReportLog?.('接口请求异常', error, {
                            level: 'info',
                            category: 'ajaxError',
                            tags
                        });
                        reject(error);
                    }
                });
            });
            setRequestStatus(RequestStatus.SUCCESS);
            return response;
        }
        catch (err) {
            setRequestStatus(RequestStatus.ERROR);
            if (err instanceof Error && err.name !== AJAX_ERROR_NAME) {
                let tags = {};
                try {
                    tags = {
                        errorInfo: JSON.stringify(err),
                        params: JSON.stringify(params)
                    };
                }
                catch (e) { }
                ctx._raptorReport.monitorReportLog?.(err.message, err, {
                    level: 'error',
                    category: 'jsError',
                    tags
                });
            }
            throw err;
        }
    };
    return {
        requestStatus,
        request
    };
}
